import type {
  QuotationItemBillingFrequencyApi,
  QuotationItemRevisionCreateRequestApi,
  QuotationItemStatusApi,
  QuotationItemUnitTypeApi,
} from 'api-typings/quotations/quotations';

/**
 * A quotation item revision
 */
export interface QuotationItemRevision {
  readonly id: number;
  readonly quotationItemId: number;
  readonly quotationId: number;
  readonly name: string;
  readonly createDate: number;
  readonly order: string;
  readonly currencyId: number;
  readonly paidAmount: number;
  readonly fundedAmount: number;
  readonly unitPrice: number;
  readonly quantity: number;
  readonly description: string;
  readonly message?: string;
  readonly invalidDate?: number;
  readonly versionInvalidDate?: number;
  readonly completeDate?: number;
  readonly quotationVersionId?: number;
  readonly unitType?: QuotationItemUnitTypeApi;
  readonly originalQuotationVersionId: number;
  readonly status?: QuotationItemStatusApi;
  readonly totalPrice: number;
  readonly unitLimit?: number;
  readonly billingFrequency?: QuotationItemBillingFrequencyApi;
  readonly quotationItemType: QuotationItemType;
}

export type QuotationItemRevisionCreateRequest =
  QuotationItemRevisionCreateRequestApi & {
    readonly previous_item_version_id: number;
  };

export enum QuotationItemType {
  HOURLY = 'hourly',
  FIXED = 'fixed',
  SUBSCRIPTION = 'subscription',
}
